/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable import/prefer-default-export */
export class MobileUtils {
  static isIosMobile = () => {
    const iOSDevice = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
    return iOSDevice;
  };
}
